"use client"
import { Box, Container, Grid2 } from "@mui/material";
import { Breadcrumbs, Link } from "@mui/material";
import { useState } from "react";
import Image from "next/image";
import styles from "./styles.module.css";

export default function Careers() {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        position: "",
        message: "",
        resume: null
    });

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        console.log(formData);
    };

    return (
        <>
            <Box height={80}></Box>
            <Container>
                <Breadcrumbs>
                    <Link
                        href="/"
                        style={{
                            color: "grey",
                            textDecoration: "none",
                        }}
                    >
                        HOME
                    </Link>
                    <Link
                        href="/careers"
                        style={{
                            color: "grey",
                            textDecoration: "none",
                        }}
                    >
                        CAREERS
                    </Link>
                </Breadcrumbs>

                <Grid2 container spacing={5} mt={3}>
                    <Grid2 size={{ xs: 12, md: 6 }}>
                        <h1 className="heading_4r" style={{ fontSize: "3.5rem", marginTop: 0 }}>
                            Join Our Team
                        </h1>
                        <p className="light_text">
                            We're always looking for talented individuals who share our passion 
                            for creating exceptional homes. Join our team of dedicated professionals 
                            and be part of something special.
                        </p>
                    </Grid2>
                </Grid2>

                <Grid2 container spacing={5} mt={5}>
                    <Grid2 size={{ xs: 12, md: 6 }}>
                        <Box
                            sx={{
                                position: "relative",
                                width: "100%",
                                aspectRatio: "4/3",
                                marginBottom: "2rem"
                            }}
                        >
                            <Image
                                src="/images/others/design.jpg"
                                alt="Team at work"
                                fill
                                style={{
                                    objectFit: "cover"
                                }}
                            />
                        </Box>
                        <h2 className="heading_3r">Why Work With Us?</h2>
                        <p className="light_text">
                            At our company, we believe in fostering a collaborative environment 
                            where innovation thrives and excellence is celebrated. We offer:
                        </p>
                        <ul className="light_text">
                            <li>Competitive compensation and benefits</li>
                            <li>Professional development opportunities</li>
                            <li>Work-life balance</li>
                            <li>Collaborative team environment</li>
                            <li>Opportunity to work on exciting projects</li>
                        </ul>
                    </Grid2>

                    <Grid2 size={{ xs: 12, md: 6 }}>
                        <Box sx={{ backgroundColor: "#f2f2ee" }} p={5}>
                            <h2 className="heading_3r">Express Interest</h2>
                            <p className="light_text" style={{ marginBottom: "2rem" }}>
                                While we don't have any current openings, we're always interested 
                                in connecting with talented professionals. Send us your information, 
                                and we'll reach out when opportunities arise.
                            </p>
                            <form onSubmit={handleSubmit}>
                                <div style={{ marginBottom: "1rem" }}>
                                    <input
                                        type="text"
                                        name="name"
                                        placeholder="Full Name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        className={styles.formInput}
                                    />
                                </div>
                                <div style={{ marginBottom: "1rem" }}>
                                    <input
                                        type="email"
                                        name="email"
                                        placeholder="Email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        className={styles.formInput}
                                    />
                                </div>
                                <div style={{ marginBottom: "1rem" }}>
                                    <input
                                        type="tel"
                                        name="phone"
                                        placeholder="Phone"
                                        value={formData.phone}
                                        onChange={handleChange}
                                        className={styles.formInput}
                                    />
                                </div>
                                <div style={{ marginBottom: "1rem" }}>
                                    <select
                                        name="position"
                                        className={styles.formInput}
                                    >
                                        <option value="">Area of Interest</option>
                                        <option value="project-management">Project Management</option>
                                        <option value="construction">Construction</option>
                                        <option value="design">Design</option>
                                        <option value="other">Other</option>
                                    </select>
                                </div>
                                <div style={{ marginBottom: "1rem" }}>
                                    <textarea
                                        name="message"
                                        placeholder="Tell us about yourself"
                                        value={formData.message}
                                        onChange={handleChange}
                                        className={styles.formInput}
                                        rows={4}
                                    />
                                </div>
                                <button type="submit" className={styles.submitBtn}>
                                    Submit
                                </button>
                            </form>
                        </Box>
                    </Grid2>
                </Grid2>
            </Container>
            <Box height={80}></Box>
        </>
    );
}
